import { Helmet } from "react-helmet-async";
import { Outlet, useOutlet } from "react-router-dom";

import { ScrollTop } from "@/components/scroll-top";
import { SiteFooter } from "@/components/site-footer";
import { SiteHeader } from "@/components/site-header";
import { Providers } from "@/components/providers";
import { META_THEME_COLORS, SITE_INFO } from "@/config/site";
import { USER } from "@/data/user";
import { fontSans } from "@/lib/fonts";
import { cn } from "@/lib/utils";

export function RootLayout() {
  const outlet = useOutlet();

  return (
    <html lang="en" suppressHydrationWarning>
      <Helmet
        title={SITE_INFO.title}
        meta={[
          { name: "description", content: SITE_INFO.description },
          { name: "keywords", content: USER.keywords },
          {
            name: "author",
            content: `${USER.displayName}`,
          },
          { property: "og:url", content: SITE_INFO.url },
          { property: "og:type", content: "website" },
          { property: "og:title", content: SITE_INFO.title },
          { property: "og:description", content: SITE_INFO.description },
          { property: "og:image", content: USER.ogImage },
          { name: "twitter:card", content: "summary_large_image" },
          { name: "twitter:site", content: `@${USER.contacts.social.twitter}` },
          { name: "twitter:creator", content: `@${USER.contacts.social.twitter}` },
          { name: "twitter:title", content: SITE_INFO.title },
          { name: "twitter:description", content: SITE_INFO.description },
          { name: "twitter:image", content: USER.ogImage },
        ]}
      >
        {/* Favicons, etc. */}
        <link rel="icon" href="https://assets.binx.com/images/favicon.ico" sizes="any" />
        <link rel="icon" type="image/svg+xml" href="https://assets.binx.com/images/favicon.svg" />
        <link rel="apple-touch-icon" href="https://assets.binx.com/images/apple-touch-icon.png" />
      </Helmet>
      <body className={cn("min-h-screen font-sans", fontSans.variable)}>
        <Providers>
          <div className="relative flex min-h-screen flex-col">
            <SiteHeader />
            <main className="flex-1">{outlet}</main>
            <SiteFooter />
          </div>

          <ScrollTop />
        </Providers>

        <meta name="theme-color" content="#ffffff" media="(prefers-color-scheme: light)" />
        <meta name="theme-color" content="#09090b" media="(prefers-color-scheme: dark)" />

        <link rel="icon" href="https://assets.binx.com/images/favicon.ico" sizes="any" />
        <link rel="icon" type="image/svg+xml" href="https://assets.binx.com/images/favicon.svg" />
        <link rel="apple-touch-icon" href="https://assets.binx.com/images/apple-touch-icon.png" />
      </body>
    </html>
  );
} 